import React from "react"
import ReactDOM from "react-dom"
import PracticalFaqContainer from "./practical-faq-container"

export default class PracticalFaqContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<PracticalFaqContainer {...self.modelJson} />, self.elem)
  }
}
